import { render, staticRenderFns } from "./AdminEditDetails.vue?vue&type=template&id=a32d2ef6"
import script from "./AdminEditDetails.vue?vue&type=script&lang=js"
export * from "./AdminEditDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports